import React, { useState, useEffect, useMemo, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import FieldInput from "../../../CustomComponents/FieldInput";
import ReactSelect from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";
import LoginLoaderButton from "../../../Common/Loader/LoginLoaderButton";
import CustomReactQuill from "../../../Common/CustomeLabel/ReactQuill/CustomReactQuill";
import {
  getIndustry,
  getWithParentCategary,
} from "../../../../redux/categary/action";
import { descriptionvalidation, filesvalidationforstatusbase, nospecialtitle, titlevalidation } from "../../../Common/commonvalidation";
import AsteriskLabel from "../../../Common/AsteriskLabel";
import CoverImages from "../../../Common/CoverImages";
import CommonCategoryOption from "../../../Common/CommonCategoryOption";
import CommonIndustryOption from "../../../Common/CommonIndustryOption";

const bxpDatatomap = [
  { title: (<>Product name <AsteriskLabel /></>), name: "title", placeholder: "Enter Title" },
  { title: (<>Industry <AsteriskLabel /></>), name: "industry_id", placeholder: "Select industry" },
  { title: (<>Category <AsteriskLabel /></>), name: "category_id", placeholder: "Select Category" },
  // {
  //   title: (<>Subcategory <AsteriskLabel /></>),
  //   name: "sub_category_id",
  //   placeholder: "Select Subcategory",
  // },
  // { title: "Price", name: "price", placeholder: "Price here" },
  {
    title: (<>Cover Image </>),
    name: "files",
    placeholder: "Drag and drop or Browse file",
  },
  { title: (<>Description <AsteriskLabel /></>), name: "description", placeholder: "Type here" },
];

const SyncParent = ({ values, setbxpData, updateindex, initialValues, setChangesIsThere }) => {
  const lastSynced = useRef("");
  const initialSnapshot = useRef(null);

  if (initialSnapshot.current === null) {
    initialSnapshot.current = JSON.stringify(initialValues);
  }

  useEffect(() => {
    const currentValues = JSON.stringify(values);
    if (lastSynced.current !== currentValues) {
      if (updateindex === null && Object.keys(values).length > 0) {
        setbxpData((prev) => ({ ...prev, ...values }));
      }
      const hasChanges = currentValues !== initialSnapshot.current;
      setChangesIsThere(hasChanges);
      lastSynced.current = currentValues;
    }
  }, [values, updateindex, setbxpData, setChangesIsThere]);
  return null;
};

const Productdetails = ({ updateindex, bxpData, setbxpData, setActiveTab, setChangesIsThere }) => {
  const [selectSubcategory, setSelectSubcategory] = useState("");
  const [loading, setLoading] = useState(null);
  const [images, setImage] = useState(null);
  const [selectCategory, setSelectCategory] = useState([]);
  const [subcategory, setSubcategory] = useState([]);
  const [selectedIndustry, setSelectedIndustry] = useState("");

  const dispatch = useDispatch();
  useEffect(() => {
    if (updateindex) {
      setImage(null);
    }
  }, [updateindex]);

  const initialValues = useMemo(() => {
    return {
      title: bxpData?.title || "",
      cover: bxpData?.cover || "",
      files: bxpData?.files || "",
      industry_id: bxpData?.industry_id || "",
      category_id: bxpData?.category_id || "",
      sub_category_id: bxpData?.sub_category_id || "",
      description: bxpData?.description || "",
      duration_type: bxpData?.duration_type || "1",
      duration: bxpData?.duration || "",
      requirements: bxpData?.requirements || "",
    };
  }, [bxpData]);

  const validationSchema = Yup.object().shape({
    title: nospecialtitle,
    industry_id: Yup.string().required("Industry is required"),
    category_id: Yup.string().required("Category is required"),
    files: filesvalidationforstatusbase,
    description: descriptionvalidation,
  });

  const path = "Assets/scss/FirstTimeUsers.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
    dispatch(getIndustry());
  }, [path]);

  const categarylist = useSelector((state) => state.categary.categarylist);
  const TheIndustryList = useSelector(({ categary: { industrylist } }) => industrylist);

  useEffect(() => {
    if (bxpData?.industry_id) {
      setSelectedIndustry(bxpData?.industry_id);
    }
  }, [bxpData?.industry_id]);

  useEffect(() => {
    if (selectedIndustry) {
      dispatch(getWithParentCategary(selectedIndustry));
    }
  }, [selectedIndustry]);

  useEffect(() => {
    if (bxpData?.category_id && categarylist?.length) {
      const selectedCategory = categarylist.find((item) => item.id == bxpData?.category_id);
      setSelectCategory(selectedCategory ? { value: selectedCategory.id, label: selectedCategory.title } : null);
    } else if (updateindex == null) {
      setSelectCategory(null);
    }
  }, [updateindex, bxpData?.category_id, categarylist]);


  const handleSubmit = async (values) => {
    setLoading(true);
    let updatedData = { ...bxpData, ...values, category_index: selectCategory };

    try {
      setbxpData(updatedData);
      setActiveTab("WorkSamples");
    } catch (error) {
      urtoast(error.message, 2); // Show error toast
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formik) => {
          return (
            <Form>
              <SyncParent
                values={formik.values}
                setbxpData={setbxpData}
                updateindex={updateindex}
                initialValues={initialValues}
                setChangesIsThere={setChangesIsThere}
              />
              <div>
                {bxpDatatomap.map((prop, key) => {
                  if (prop.name == "description") {
                    return (
                      <>
                        <CustomReactQuill
                          value={formik.values[prop.name]}
                          formik={formik}
                          name={prop.name}
                          title={prop.title}
                        />
                        <ErrorMessage
                          name={prop.name}
                          component="div"
                          className="error"
                          style={{ color: "red" }}
                        />
                      </>
                    );
                  }
                  if (prop.name == "industry_id") {
                    return (
                      <CommonIndustryOption
                        key={key}
                        options={TheIndustryList}
                        formik={formik}
                        prop={prop}
                        setSelectedIndustry={setSelectedIndustry}
                        setSelectCategory={setSelectCategory}
                      />
                    );
                  }

                  if (prop.name == "category_id") {
                    return (
                      <>
                        <CommonCategoryOption
                          key={key}
                          formik={formik}
                          prop={prop}
                          options={categarylist}
                          selectCategory={selectCategory}
                          setSelectCategory={setSelectCategory}
                        />
                      </>
                    );
                  }

                  if (prop.name == "sub_category_id") {
                    if (Array.isArray(subcategory) && subcategory.length != 0) {
                      return (
                        <div className="form-group" key={key}>
                          <label>{prop.title}</label>
                          <ReactSelect
                            options={
                              Array.isArray(subcategory) &&
                              subcategory.map((lang) => ({
                                value: lang.id,
                                label: lang.title,
                              }))
                            }
                            placeholder="Select An Option"
                            value={selectSubcategory}
                            onChange={(options) => {
                              setSelectSubcategory(options);
                              formik.setFieldValue(
                                "sub_category_id",
                                options.value
                              );
                              formik.setFieldValue("subcategory_index", options);
                              formik.setFieldValue(
                                "sub_category_title",
                                options.label
                              );
                            }}
                          />
                          <ErrorMessage
                            name={prop.name}
                            component="div"
                            className="error"
                          />
                        </div>
                      );
                    } else return null;
                  }
                  if (prop.name == "files") {
                    return (
                      <div className="form-group upload-item-images" key={key}>
                        <CoverImages
                          formik={formik}
                          doctype={1}
                          type={'multiple'}
                          name={prop.name}
                          title={prop.title}
                        />
                        <ul className="border-ul">
                          <li>Images (JPG, PNG, JPEG up to 10MB)</li>
                        </ul>
                      </div>
                    );
                  }

                  return (
                    <FieldInput
                      title={prop.title}
                      name={prop.name}
                      placeholder={prop.placeholder}
                      key={key}
                    />
                  );
                })}
                <div className="button-container">
                  <button className="next-button w-100" type="submit">
                    {loading ? <LoginLoaderButton /> : "Next"}
                  </button>
                </div>
              </div>
            </Form>
          )
        }}
      </Formik>
    </div>
  );
};

export default Productdetails;
